import * as React from "react";
import SetInterval from "set-interval";
import Modal from "@tunnel-components/@sharded/modal/healthCheck/container";
import * as Utils from "@Cyclope-Utils/index";

const TunnelToken = (): any =>
  Utils.localStorageIsKeyExist() && Utils.localStorageIsKeyExist();

const fetchWithTimeout = async (resource: string, timeout: number = 300) => {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  const response = await fetch(resource, {
    cache: "default",
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: String("Bearer " + TunnelToken()),
      "Content-Type": "application/json",
    },
    signal: controller.signal,
  });
  clearTimeout(id);

  return response;
};

class Component extends React.PureComponent<any, any> {
  public constructor(props: any) {
    super(props);
    this.state = { switch: false, count: 0, message: null };
    this.checkHealth = this.checkHealth.bind(this);
    this.checkServerFallbackHealth = this.checkServerFallbackHealth.bind(this);
  }

  public async checkHealth() {
    const CFG_NAMESPACE = "check";
    const CHECK1 = window[CFG_NAMESPACE].URL_HEALTH_CHECK;
    try {
      const res = await fetchWithTimeout(CHECK1, this.props.timeout);
      let resJSON = { status: "DOWN" };
      if (res.ok) {
        resJSON = await res.json();
      }

      const switchVal =
        this.state.switch && res.ok && resJSON.status === "UP"
          ? false
          : this.state.switch;

      this.setState((state) => ({
        ...state,
        switch: switchVal,
        count: !res.ok || resJSON.status !== "UP" ? state.count + 1 : 0,
      }));
    } catch (error) {
      this.setState((state) => ({ ...state, count: state.count + 1 }));
    }
  }

  public async checkServerFallbackHealth() {
    const CFG_NAMESPACE = "check";
    const CHECK2 = window[CFG_NAMESPACE].URL_HEALTH_CHECK_FALLBACK;
    if (this.state.count >= window[CFG_NAMESPACE].CHECK_RETRY) {
      try {
        const res = await fetchWithTimeout(CHECK2, this.props.timeout);
        let resJSON = { status: "DOWN" };
        if (res.ok) {
          resJSON = await res.json();
        }
        this.setState({
          switch: true,
          message:
            !res.ok || resJSON.status !== "UP"
              ? "Aucun serveur ne répond"
              : null,
        });
      } catch (error) {
        this.setState({ switch: true, message: "Aucun serveur ne répond." });
      }
    }
  }

  public componentDidUpdate() {
    const CFG_NAMESPACE = "check";
    if (this.state.count === window[CFG_NAMESPACE].CHECK_RETRY) {
      SetInterval.start(
        this.checkServerFallbackHealth,
        window[CFG_NAMESPACE].CHECK_DELAY_FALLBACK,
        "check2"
      );
    }
  }

  public componentDidMount() {
    SetInterval.start(this.checkHealth, this.props.delay, "check1");
  }

  public componentWillUnmount() {
    SetInterval.clear("check1");
    SetInterval.clear("check2");
  }

  public render() {
    return <Modal isVisible={this.state.switch} message={this.state.message} />;
  }
}

export default Component;



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/healthCheck/index.tsx